module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"focus categories":"включить категории","exclude categories":"исключить категории","All categories":"Все категории"}}')
  delete Component.options._Ctor
}
